import {
    apiExistsInAufschaltung,
    checkApiIdPattern,
    feedExistsForProfileAndApi } from './card_helper'

import { format } from './docu/format.js';
import { faq } from './docu/faq.js';
import { best_practices } from './docu/best_practices.js';
import { news } from './docu/news.js';

  const cardDefinitionsDe = [
/* Dashboard Cards ID: 1xx-de *************************************************/
// TODO remove if read / show only if new user?
    {
      id: '101-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Hallo {{ userInfo.nickname }}, willkommen beim dpa-infocom-API-Portal',
      description: `
  Hier finden Sie alle Informationen rund um die Belieferung mit dpa-infocom-Inhalten via API.
   * Technische Informationen wie URL-Endpunkte, Protokolle und Credentials.
   * Dokumentation der Formate 
   * Testzugänge zu alternativen API-Formaten
  
  Zum Einstieg empfehlen wir Ihnen den <NavLink exact to="/doc/overview">Überblick</NavLink>.
  
  Falls Sie Informationen vermissen oder sonstige Fragen haben, zögern Sie nicht, mit uns <NavLink exact to="/contact">Kontakt aufzunehmen</NavLink>.
  `,
      data: {with_minify: true}
    },
  /* Use when implemented properly
    {
      id: '102',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'API-Statistik',
      description: `
  <dashboardfeedstatistics></dashboardfeedstatistics>
    `},

    {
      id: '103',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Mitteilungen',
      description: `
  <dasboardnotifications></dashboardnotifications>
    `},

    {
      id: '104',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.dashboard)
      },
      title: 'Logs',
      description: `
  <dashboardlog></dashboardlog>
    `},
  */

/* Profile Cards **************************************************************/
    {
      id: '201-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.profile === 'ALL')
      },
      title: 'Was sind Profile',
      description: `Profile sind vordefinierte Selektionen von dpa-infocom-Inhalten. Profile können enthalten
  * Eine oder mehrere Webline-Rubriken
  * Eine oder mehrere dpa-news-Rubriken
  * Eine oder mehrere dpa-Dienste -- z.B. Basisdienst, Landesdienste oder Bildfunk.
    `},

    {
      id: '202-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
                !checkApiIdPattern(context, 'api-apigate'))
      },
      title: 'Inhalte',
      description: `
  Folgende Inhalte sind in «{{ profile.nickname }}» enthalten
  <ul class="tag_regexp">
  {% if profile.ored_tag_regexps %}
    {% for exp in profile.ored_tag_regexps %}
      <li><Label className='query-bupperl {{exp.kind}}'><span className='kind'>{{exp.kind_title}}</span>{{exp.title}}</Label></li>
    {% endfor %}
  {% elseif profile.query_ored_tag_regexps %}
    {% for exp in profile.query_ored_tag_regexps %}
      <li><Label className='query-bupperl {{exp.kind}}'><span className='kind'>{{exp.kind_title}}</span>{{exp.title}}</Label></li>
    {% endfor %}
  {% endif %}
  </ul>
    `}, // TODO: PROD in sync with DEV cf3 api no ored_tag_regexps needed anymore

  /***
    {
      id: '203-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          !feedExistsForProfileAndApi(context, 'jsonfeed') &&
          !feedExistsForProfileAndApi(context, 's3push'))
      },
      title: 'Hinweis',
      description: `Für das Profil {{ profile.nickname }} ist kein jsonfeed verfügbar.`,
      data: {
        with_selection: false
      }
    },
  ***/

    {
      id: '204-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          feedExistsForProfileAndApi(context, 'graphql'))
      },
      title: 'Hinweis',
      description: `Das Profil {{ profile and profile.nickname }} ist per <NavLink exact to='/api/graphql'>Graphql-API</NavLink> abrufbar.`
    },

    {
      id: '205-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          feedExistsForProfileAndApi(context, 'graphqlapikp'))
      },
      title: 'Aktuelle Artikel in «{{ profile.nickname }}»',
      description: `
  <feedcontentbrowser></feedcontentbrowser>
    `},

  //  {
  //  id: '206-de',
  //    kind: 'default',
  //    matches: (context) => {
  //      return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
  //        feedExistsForProfileAndApi(context, 'jsonfeed'))
  //    },
  //    title: 'Feed-URL / Abrufbeispiel',
  //    description: `
  //Abruf als jsonfeed von der Kommandozeile
  //
  //<Message>curl -o - {{ feed and feed.feed_url }}</Message>
  //  `},
  
  //  {
  //    id: '207-de',
  //    kind: 'default',
  //    matches: (context) => {
  //      return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
  //        feedExistsForProfileAndApi(context, 'jsonfeed'))
  //    },
  //    title: 'Dokumentation des Json-Feed-Formats',
  //    description: `Im Bereich API/Json-Feed finden Sie die <NavLink exact to="/doc/overview">Beschreibung des jsonfeed-Formats</NavLink>.`
  //  },

    {
      id: '208-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile === 'myline-3' &&
          feedExistsForProfileAndApi(context, 'wds'))
      },
      title: 'Zugang per FTP',
      description: `Angaben zu Ihrer FTP-Belieferung
  
      * format: nitf
      * host: ftp.customersite.com
      * port 21
      * ftp-mode passive
    
    ### Hinweis
    
    Ihr FTP-Zugang zum Profil myline-3 ist bis zum 31.9.2018 befristet. 
    
    Bitte <NavLink exact to='/doc/support-contact'>kontaktieren Sie den Support</NavLink> wenn Ihren den Vertrag anpassen möchten.`
    },

    {
      id: '209-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 's3push')
      },
      title: 's3push-API',
      description: `
  <apis3pushwizard></apis3pushwizard>
    `},

    {
      id: '210-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate'))
      },
      title: 'Allgemein',
      description: `Die Daten des Profils «{{ profile and profile.nickname }}»
      sind unter dem Menüpunkt APIs abrufbar.
    `},

    {
      id: '211-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate-survey'))
      },
      title: 'Inhalte',
      description: `Aktuelle Umfrageergebnisse. Die Daten des Profils «{{ profile and profile.nickname }}» sind unter 
      <NavLink exact to='/api/survey'>API | survey</NavLink> abrufbar.
    `},

    {
      id: '212-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && !!context.navigation.profile && context.navigation.profile !== 'ALL' &&
          checkApiIdPattern(context, 'api-apigate-electionsdata'))
      },
      title: 'Inhalte',
      description: `Aktuelle Daten zu Wahlen und Umfragen. Die Daten des Profils «{{ profile and profile.nickname }}» sind unter 
      <NavLink exact to='/api/electionsdata'>API | electionsdata</NavLink> abrufbar.
    `},

    {
      id: '213-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'sftppush')
      },
      title: 'sftppush-API',
      description: `
  <apisftppushwizard></apisftppushwizard>
    `},

/* API Cards ******************************************************************/
    {
      id: '301-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'ALL')
      },
      title: 'APIs von dpa-infocom — ein Überblick',
      description: `dpa-infocom bietet Ihnen verschiedene APIs an.

  Je nach Einsatzzweck ...
  * json-feed, graphql, notification ...
  * klassisch NITF per FTP... 
  * ...spezielle APIs...projektor... 
  
  Erfahren Sie mehr über die konkreten APIs:
  
  * <Navlink exact to="/api/jsonfeed">jsonfeed-API</NavLink>
  * <Navlink exact to="/api/s3push">s3push-API</NavLink>
  * <Navlink exact to="/api/annotation">Annotation-API</NavLink>
  * ...
    `},

    {
      id: '302-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'Feed-URL',
      description: `
  
  <apifeedurlbrowser></apifeedurlbrowser>
  
    `},

    {
      id: '303-de',
      kind: 'default',
      matches: (context) => {
        // only if any feedselection accessible by jsonfeed-api
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'jsonfeed-Format',
      description: `Im Bereich Dokumentation finden Sie die <Navlink exact to="/doc/overview#was-ist-die-jsonfeed-api">Beschreibung der jsonfeed-API</Navlink>.`
    },

    {
      id: '304-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'Inhalt der Feeds',
      description: `
  <apijsoncontentbrowser></apijsoncontentbrowser>
    `},

    {
      id: '305-de',
      kind: 'default',
      matches: (context) => {
        return false // (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'jsonfeed')
      },
      title: 'Was sind jsonfeeds?',
      description: 'Die jsonfeed-API stellt eine Liste der neusten Meldungen unter einem Feed-URL zum Abruf per HTTPS zur Verfügung. Dabei kommt das JSON-Format zum Einsatz ...'
    },

    {
      id: '306-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'projektor')
      },
      title: 'Projektor-API',
      description: 'Die Projektor-API ermöglicht es Ihnen, Bilder in individuell definierbaren Formaten zu beziehen ....'
    },

    {
      id: '307-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'Graphql-Endpunkt',
      description: `
  Unter diesem URL können Sie die Inhalte per graphql abrufen.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},

    {
      id: '308-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'Graphql-API',
      description: `
  
  Hier können Sie die Graphql-API ausprobieren.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },
  
    {
      id: '309-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'graphql')
      },
      title: 'Wie benutze ich die Graphql-API?',
      description: `
  TODO... TODO... TODO... TODO... TODO...TODO...TODO...
  
  ....
  
  TODO... TODO... TODO... TODO... TODO...TODO...TODO...
  `,
      data: {}
    },

    {
      id: '310-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-Endpunkt',
      description: `
  Unter diesem URL können Sie Annotationen per graphql abrufen.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},

    {
      id: '311-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-Format',
      description: `Im Bereich Dokumentation finden Sie die <Navlink exact to="/doc/overview#was-ist-die-annotation-api">Beschreibung der Annotation-API.</Navlink>.`
    },

    {
      id: '312-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'annotation')
      },
      title: 'Annotation-API',
      description: `
  
  Hier können Sie die Annotation-API ausprobieren.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },

    {
      id: '313-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'tryout')
      },
      title: 'tryout-Format',
      description: `Im Bereich Dokumentation finden Sie die <Navlink exact to="/doc/overview#was-ist-die-tryout-api">Beschreibung der tryout-API.</Navlink>.`
    },

    {
      id: '314-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'tryout')
      },
      title: 'Tryout-API',
      description: `
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },

    {
      id: '315-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'base')
      },
      title: 'Newslab-Base-API-Endpunkt',
      description: `
  Unter diesem URL können Sie die topicles aus der Newslab-Base-API per graphql abrufen.
  
  <Message>{{ feed.graphql_endpoint_url }}</Message>
      `},

    {
      id: '316-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'base')
      },
      title: 'Newslab-Base-API',
      description: `
  
  Hier können Sie die Newslab-Base-API ausprobieren.
  
  <apigraphqlbrowser></apigraphqlbrowser>
  `,
      data: {}
    },

    {
      id: '317-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'wireq')
      },
      title: 'wireQ-API',
      description: `
<apiwirequrlbrowser></apiwirequrlbrowser>

  `},


  {
    id: '318-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'wireq')
    },
    title: 'wireQ-Schema',
    description: `

<Message class="schema-doc-md">
{{ feed.schema_doc_md }}
</Message>

<p>
  Im Bereich Dokumentation finden Sie die <Navlink exact to="/doc/overview#was-ist-die-wireq-api">Beschreibung der wireQ-API</Navlink>.
</p>

  `},

  {
    id: '319-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'imagewriter')
    },
    title: 'Imagewriter-Endpunkt',
    description: `
Unter diesem URL können Sie Imagewriter per graphql abrufen.

<Message>{{ feed.graphql_endpoint_url }}</Message>
  `},

  {
    id: '320-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'imagewriter')
    },
    title: 'Imagewriter-API',
    description: `

Hier können Sie die Imagewriter-API ausprobieren.

<apigraphqlbrowser></apigraphqlbrowser>
`,
    data: {}
  },

  {
    id: '321-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung &&
        checkApiIdPattern(context, 'api-apigate') && context.navigation.api &&
        !['wireq', 's3push', 'jsonfeed', 'imagewriter', 'annotation', 'tryout'].some(a => context.navigation.api.includes(a)))
    },
    title: '{{api.nickname}}-Endpunkt',
    description: `
Unter diesem Basis-URL können Sie die {{api.nickname}}-API erreichen.

<Message>{{ feed.base_url }}</Message>
  `},

  {
    id: '322-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung &&
        checkApiIdPattern(context, 'api-apigate') && context.navigation.api &&
        !['wireq', 's3push', 'jsonfeed', 'imagewriter', 'annotation', 'tryout'].some(a => context.navigation.api.includes(a)))
    },
    title: '{{api.nickname}}-API Kurzdokumentation',
    description: `

<Message class="schema-doc-md">
{{ feed.schema_doc_md }}
</Message>

  `},

  {
    id: '323-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'survey')
    },
    title: '{{api.nickname}}-API',
    description: `
<p>
  Im Bereich Dokumentation finden Sie die <Navlink exact to="/doc/overview#was-ist-die-survey-api">Beschreibung der survey-API</Navlink>.
</p>

  `},

  {
    id: '324-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'electionsdata')
    },
    title: '{{api.nickname}}-API',
    description: `
<p>
  Details zu den Ressourcen und Parametern finden Sie in der <a href="https://swagger.dpa-electionsdata.com" target="_blank">Beschreibung der {{api.nickname}}-API</a>.
</p>

  `},

  {
    id: '325-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.aufschaltung && context.navigation.api === 'agenda')
    },
    title: '{{api.nickname}}-API',
    description: `
<p>
  Details zu den Ressourcen und Parametern finden Sie in der <a href="https://dpa-connect-common-static-pages.s3.eu-central-1.amazonaws.com/agenda/api-doc/index.html" target="_blank">Beschreibung der {{api.nickname}}-API</a>.
</p>

  `},
      
/* APP Cards ******************************************************************/
    {
      id: '401-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'ALL')
      },
      title: 'Apps',
      description: 'Bitte wählen Sie eine konkrete App aus dem Menü aus.'
    },

    {
      id: '402-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'cli')
      },
      title: 'dpa-Commandline-Interface',
      description: 'Das Command-Line-Interface (dpa-cli) ermöglicht den Download von Feed-Inhalten. Es liegt als nodejs-Package vor und wird lokal installiert.\n'
    },

    {
      id: '403-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'cli')
      },
      title: 'Kurze Einführung in das Commandline-Interface',
      description: `
  
    Installieren ...
    \`\`\`bash 
    yarn add dpacli 
    \`\`\` 
    Registrieren Sie ihre credentials ... .
    \`\`\`bash 
    dpa config 
    \`\`\` 
    Sie können dann ... 
    \`\`\`bash
    dpa receive 
    \`\`\` 
    Die empfangenen Meldungen werden ...
    `},

    {
      id: '404-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'showcase')
      },
      title: 'dpa-Showcase',
      description: `
  Im dpa-Showcase können Sie sich die aktuellen Inhalte Ihrer Profile anschauen.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
      data: {
        app_link_url: 'https://showcase.dpa-info.com'
      }
    },

    {
      id: '405-de',
      kind: 'default', //  'app-description',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'schalttafel')
      },
      title: 'dpa-Schalttafel',
      description: `
  
  Die dpa-Schalttafel ist ein Agentureingangssystem, das Ihre Profile übersichtlich in Spalten darstellt. Importieren Sie Texte und Bilder einfach per Drag-and-Drop aus der Schalttafel in Ihr eigenes CMS.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
  
      data: {
        app_link_url: 'https://schalttafel3.dpa-newslab.com'
      }
    },
  
    {
      id: '406-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'executive')
      },
      title: 'dpa-executive',
      description: `
  
  dpa-executive ist eine mobile app fuer iOS, android und web.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,

      data: {
        app_link_url: 'https://dpa-executive.com/'
      }
    },

    {
      id: '407-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.aufschaltung && context.navigation.app === 'probe')
      },
      title: 'probe',
      description: `
  
  probe ist eine protoypische news-app aus dem dpa-newlab.
  
  <Message>
  <a href="{{ card.data.app_link_url }}" target="_blank">{{ card.data.app_link_url }}</a>
  </Message>
  `,
      data: {
        app_link_url: 'https://d22rhyjaupeni6.cloudfront.net'
      }
    },

/* Doc Cards ******************************************************************/
    {
      id: '601-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'intro-api')
      },
      title: 'Einführung in die dpa-API-Welt',
      description: `
  
  <embed id='9b0GL2fXh3A' source='youtube' placeholder='/img/mapisw.png' />
    `},

    {
      id: '602-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.contact === 'ALL')
      },
      title: 'Kontakt',
      description: `
  Sie benötigen Hilfe? Unser Service-Team steht Ihnen für Fragen gerne zur Verfügung!
  
  Bitte melden Sie sich bei uns:
  
  * **E-Mail**: kundenservice.desk@dpa.com
  * **Telefon**: +49 40 4113-32600
    `},
  
    {
      id: '603-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'ALL')
      },
      title: 'Übersicht',
      description: `
  An dieser Stelle finden Sie mehr Informationen zu folgenden Themen:
  
  * <Navlink exact to="/doc/overview">Überblick</NavLink>
  * ...
  
    `},

    {
      id: '604-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview')
      },
      title: 'Was ist das dpa-digitalwires-format?',
      description: `
<table border="0">
  <tr>
    <td align=justify valign=top><p>Das dpa-digitalwires-Format ist ein JSON-basiertes Datenformat, das
    multimediale Nachrichteninhalte von dpa und anderen Agenturen transportiert. Insbesondere gehören dazu:</p>
<ul><li>dpa-Weblines</li><li>dpa-Textfunk</li><li>dpa-Bildfunk</li></ul>
<p>
Das dpa-digitalwires-Format beschreibt sogenannte <strong>Topicles</strong>. Topicles vereinen
Aspekte von multimedialen Artikeln und Containern.
</p>
<p>
Dadurch können sowohl rein textuelle Artikel, multimediale Artikel mit Text und Bild
als auch Aggregate aus mehreren Texten und beliebigen weiteren Assets als ein kohärentes
JSON-Objekt repräsentiert werden.
</p>
<p>
Das dpa-digitalwires-Format orientiert sich an den Anforderungen sowohl für den Import
in Redaktionssysteme als auch für die automatische Publikation.

Mehr zum Thema:
* <Navlink exact to="/doc/format">Dokumentation des dpa-digitalwires Formats</NavLink>
</p>
   </td>
   <td style="padding: 0 0 0 20px;" valign=top>
     <img width: 100% height=auto src="/img/grafik-dw-format.png">
   </td>
  </tr>
 </table>
    `},

    {
      id: '605-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 's3push'))
      },
      title: 'Was ist die s3push-API?',
      description: `
S3push überträgt neue oder aktualisierte Artikel direkt in ein S3 Bucket
des dpa-Kunden. Von dort können die Artikel regelmäßig abgeholt werden.

Oder sie werden mittels cloudbasierter Funktionen (AWS-Lambda)
in kundenspezifische Formate transformiert und automatisch ins CMS importiert.

![s3push-diagramm](/img/s3push-wide.png)

S3push stellt eine moderne, cloudbasierte Alternative zur Auslieferung per FTP-Push dar.
Es entfällt die Notwendigkeit, selbst einen FTP-Server zu betreiben.

Mehr zum Thema:
  * <Navlink exact to="/doc/apis#dokumentation-s3push-api">Dokumentation s3push-API</NavLink>
  * <Navlink exact to="/doc/s3push-alternative-install">s3push alternative Installationmethoden</NavLink>
    `},

    {
      id: '606-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'wireq'))
      },
      title: 'Was ist die wireQ-API?',
      description: `
  Die wireQ-API ermöglicht es, alle aktuellen Artikel inklusive Metadaten
  und Links auf individuelle Bildformate über eine queue-basierte Belieferung zu bekommen.
  
  In der Queue befinden sich alle noch nicht importierten Artikel, die sich mittels
  eines einfachen Restful-Requests abrufen lassen. Nach erfolgreichem Import
  werden die Artikel aus der Queue gelöscht.
  
  ![wireq-diagramm](/img/wireq-wide.png)
  
  Im Vergleich zum jsonfeed sinkt auf der Seite des Importers der Aufwand zur
  Erkennung von neuen zu importierenden Topicles. Außerdem ist die übertragene
  Datenmenge geringer.
  
  Bei einem AusfallI des Importers werden die Artikel zuverlässig in der
  Queue vorgehalten, auch über mehrere Tage.
  
  Mehr zum Thema:
  * <Navlink exact to="/doc/apis#dokumentation-wireq-api">Dokumentation wireQ-API</NavLink>
      `},

    {
      id: '607-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'jsonfeed'))
      },
      title: 'Was ist die jsonfeed-API?',
      description: `
Die jsonfeed-API ermöglicht es, alle aktuellen Artikel inklusive Metadaten und Links auf individuelle Bildformate 
mit einem einfachen HTTP-Request abzuholen.

Strukturell ähneln die Feeds den bekannten Atom-XML- oder RSS-Feeds. Als Datenformat kommt hier jedoch
JSON zum Einsatz.  

Jsonfeeds werden vom dpa-Kunden regelmäßig abgeholt, hierbei handelt sich also um ein „Pull-Szenario”.

![jsonfeed-diagramm](/img/jsonfeed-wide.png)

Mehr zum Thema:
* <Navlink exact to="/doc/apis#dokumentation-jsonfeed-api">Dokumentation jsonfeed-API</NavLink>
    `},
  
  //   * Anwendungsszenarien für jsonfeed

  //  * <Navlink exact to="/doc/s3push-scenarios">Anwendungsszenarien für s3push</NavLink>

    {
      id: '608-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'projektor'))
      },
      title: 'Was ist Projektor?',
      description: `
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
  
    * Kundenspezifische Bildformate
    * Kundenspezifische Metadaten
  
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua.
    `},

    {
      id: '609-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'graphql'))
      },
      title: 'Was ist die GraphQL-API?',
      description: `
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
  
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
  dolore magna aliquyam erat, sed diam voluptua.
    `},

    {
      id: '610-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'annotation'))
      },
      title: 'Was ist die Annotation-API?',
      description: `
  Über die Annotation-API können dpa-Kunden ergänzende Informationen zu Artikeln abrufen,
  die sie via s3push, wireq, jsonfeed oder andere Wege erhalten haben. Der initiale Use Case ist die Auslieferung von Performant Content Metadaten an Weblineskunden, die die Inhalte noch per FTP im Format NITF beziehen.
  
  Die Annotation-API basiert auf GraphQL. Hierbei können die API-User auf der Grundlage
  eines Schemas selber festlegen, welche Attribute sie abrufen wollen.
  Die Annotation-API lässt sich direkt im API-Portal ausprobieren.
  (Siehe <NavLink exact to="/api/annotation">API | annotation</NavLink>)
  
  Der Ablauf sieht auf Seiten des dpa-Kunden so aus:
  
  * Artikel-ID ermitteln
  * GraphQL-Anfrage stellen
  * Ergebnis auswerten
  
  ![annotation-api-diagramm](/img/annotation-wide.png)
  
  Mehr zum Thema
    * <Navlink exact to="/doc/apis#annotation">Dokumentation Annotation-API</NavLink>
  
    `},

    {
      id: '611-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'tryout'))
      },
      title: 'Was ist die tryout-API?',
      description: `
Die tryout-API ist eine GraphQL-API, die zum Testen und Weiterentwicklungen innerhalb
des dpa-newslabs verwendet wird.
      `},

    {
      id: '612-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'overview' &&
          apiExistsInAufschaltung(context, 'base'))
      },
      title: 'Was ist die base-API?',
      description: `
  Die base-API ist eine GraphQL-API, die verschiedene Objekte der Nachrichtenproduktion bei dpa zugänglich macht.
  
  Die base-API soll iterativ um immer mehr Anwendungsbereiche erweitert werden.
  
  Erste Schritte:
    * Simple Topicles from Tank
    * Image Retrieval
    * Topicle Search
    * Blockchain for everything
    * Transmission of sports results by quantum entanglement
    
    `},

    {
      id: '613-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 's3push-alternative-install')
      },
      title: 'Alternative Installationsmethoden zu s3push',  
      description: `
  #### Manuelle Einrichtung in der AWS-Console
  
  Im Folgenden wird die manuelle Einrichtung von s3push mittels AWS-Console beschrieben.
  Diese Installation reicht für eine einfache Belieferung mit s3push.
  
  Insbesondere wenn Sie die empfangenen JSON-Artikel per Lambda-Funktion in ein anderes Format wandeln oder 
  nachfolgende Systeme notifizieren wollen, empfehlen wir ihnen die Beispiel-Projekte auf der Basis von \`serverless.yml\`.
  Sie sparen dadurch einiges an Zeitaufwand bei der Einrichtung.
  
  #### 1. S3 Bucket erzeugen
  
  In der  <a href="https://s3.console.aws.amazon.com/s3" target="_blank">AWS S3-Console</a>
  
  #### 2. IAM-Person hinzufügen
  
  In der <a href="https://console.aws.amazon.com/iam/home#/users" target="_blank">AWS Identity and Access Management (IAM)</a>

  * Personendetails -> programmgesteuerter Zugriff
  * Berechtigungen festlegen -> Direktes Anfügen von Richtlinien -> Richtlinie erstellen
  
  #### 3. Richtlinie erstellen
  
  In der <a href="https://console.aws.amazon.com/iam/home#/policies" target="_blank">AWS IAM-Console Policies</a>
  
  Nach Anpassung der Resource (\`{s3_s3push_bucket_name}\` und \`{s3_s3push_prefix}\`)
  kann folgende minimale Policy unter dem Reiter "JSON" eingefügt werden:
  \`\`\`bash
  {
    "Version": "2012-10-17",
    "Statement": [
      {
        "Sid": "Statement1",
        "Effect": "Allow",
        "Action": [
          "s3:PutObject",
          "s3:GetObject",
          "s3:GetBucketLocation"
        ],
        "Resource": [
          "arn:aws:s3:::{s3_s3push_bucket_name}",
          "arn:aws:s3:::{s3_s3push_bucket_name}/{s3_s3push_prefix}*"
        ]
      }
    ]
  }
  \`\`\`
  
  #### 4. Cross-Origin Resource Sharing (CORS) Konfiguration
  Zur Anzeige der Vorschau der Daten aus dem jeweiligen S3 Bucket muss das
  domänenübergreifende Ressourcen-Sharing mit CORS aktiviert werden
  (S3 Bucket -> Berechtigungen -> Cross-Origin Resource Sharing (CORS)).
  
  Hierzu sind folgende Einstellungen nötig
  (siehe auch <a href="https://docs.aws.amazon.com/de_de/AmazonS3/latest/user-guide/add-cors-configuration.html" target="_blank">AWS-Dokumentation zu S3-CORS</a>).
  
  \`\`\`json
    [
        {
            "AllowedHeaders": [
                "*"
            ],
            "AllowedMethods": [
                "GET",
                "HEAD"
            ],
            "AllowedOrigins": [
                "*"
            ],
            "ExposeHeaders": [],
            "MaxAgeSeconds": 3000
        }
    ]
  \`\`\`
  
  #### 5. Daten übernehmen
  Nachdem der jeweilige User mit der angebenen Policy angelegt ist, können die 
  benötigten Daten (**Access key ID** und **Secret access key**) erzeugt werden und mittels "Kopieren und Einfügen"
  in das API-Portal übernommen werden.
    `},

    {
      id: '614-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'apis') 
      },
      title: 'API-Vergleich',
      description: `
<table border=1 cellspacing=0 cellpadding=10>
  <tr>
    <th></th>
    <th>s3push-API</th>
    <th>wireQ-API</th>
    <th>jsonfeed-API</th>
  </tr>
  <tr>
    <td valign=top><strong>Formatvarianten</strong></td>
    <td valign=top>JSON (weitere Formate durch Transformationsfunktion auf Kundenseite möglich)</td>
    <td valign=top>JSON</td>
    <td valign=top>JSON/RSS</td>
  </tr>
  <tr>
    <td valign=top><strong>Szenario</strong></td>
    <td valign=top>event-basiert</td>
    <td valign=top>restful-queue</td>
    <td valign=top>restful</td>
  </tr>
  <tr>
    <td valign=top><strong>Prinzip der Belieferung</strong></td>
    <td valign=top>Die Daten werden in einen vom Kunden bereitgestellten S3 Bucket übertragen</td>
    <td valign=top>Der Client empfängt Daten von der cloud-basierten Warteschlange</td>
    <td valign=top>zeitverzögerte (oder Rubrik basierende) Aggregation indem der Client die API pollt</td>
  </tr>
  <tr>
    <td valign=top><strong>Transportierte Datenmengen</strong></td>
    <td valign=top>nur neue oder aktualisierte Topicles</td>
    <td valign=top>nur neue oder aktualisierte Topicles</td>
    <td valign=top>immer alle Topicles des Feeds</td>
  </tr>
  <tr>
    <td valign=top><strong>Import ins CMS</strong></td>
    <td valign=top>einfacher Import, da nur neue oder aktualisierte Topicles einlaufen</td>
    <td valign=top>einfacher Import, da nur neue oder aktualisierte Topicles einlaufen</td>
    <td valign=top>hoher Aufwand zur Erkennung neu zu importierender Topicles, da immer alle Topicles des Feeds übermittelt werden</td>
  </tr>
  <tr>
    <td valign=top><strong>Kosten</strong></td>
    <td valign=top>günstig</td>
    <td valign=top>mittel</td>
    <td valign=top>hoch</td>
  </tr>
  </table>
    `},

    {
      id: '615-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 's3push-scenarios')
      },
      title: 'Anwendungsszenarien für s3push',
      description: `
Im Folgenden werden verschiedene Anwendungsszenarien für s3push dargestellt.

#### CMS-Import aus S3

Vielen aktuelle Weblines-Kunden nutzen die Import-Funktionalität ihres CMS um Weblines
und dpa Meldungen aus dem Dateisystem des FTP Servers zu importieren.
Der Import erfolgt zumeist zeit- in fortgeschritteneren Fällen auch eventgesteuert
und beinhaltet in der Regel eine Formattransformation in das Importformat des CMS.

AWS S3 (Simple Storage System) ist der defacto Standard für cloudbasierte Dateispeicher.
Diese bieten neben der Tatsache, dass Sie praktisch nicht vollaufen können
(ein häufiges Problem bei FTP Servern) eingebaute Sicherheit durch die Verwendung von HTTPS.

Die Möglichkeit, dass beim Anlegen einer neuen Datei eine Lambdafunktion aufgerufen
werden kann, erlaubt es, sowohl Formattransformationen, als auch Notifikationen an
das CMS resp. andere nachgelagerte Systeme vorzunehmen.
    `},

  // ------------------------ s3push deep-dive 
  {
    id: '616-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.navigation.doc === 'apis' &&
      apiExistsInAufschaltung(context, 's3push'))
    },
    title: 'Dokumentation s3push-API',
    description: `
### Überblick
S3push stellt eine moderne, cloudbasierte Alternative zur Auslieferung per FTP-Push
dar. Es entfällt die Notwendigkeit, selbst einen FTP-Server zu betreiben.

S3push überträgt neue oder aktualisierte Artikel direkt in das S3 Bucket
des dpa-Kunden. 

Jeder Artikel wird in einer JSON-Repräsentation (s.u.) unter seinem eigenen Key 
abgelegt. Im Key enthalten ist ein Timestamp und ein Hash, so dass Updates ihren eigenen Key erhalten.

Um die eingehenden Artikel weiterzuverarbeiten, kann eine Lambda-Funktion an das Bucket
gebunden werden. Trifft ein neuer Artikel ein, so wird die Funktion aufgerufen. 
Auf diese Weise könnnen Formatwandlungen und Trigger programmiert werden.

Wir haben dazu einige Code-Beispiele vorbereitet (siehe Abschnitt "Anlegen von Konvertierungsfunktionen").

![s3push-diagramm](/img/s3push-wide.png)

#### Best Practices

Auf Github hat das dpa-newslab einige Beispielimplementierungen für den Umgang mit der s3push-API veröffentlicht:

* <NavLink exact to="/doc/best-practices#s3push-anbindung">s3push Anbindung</NavLink>

#### Vergleich s3push mit FTP

Eigenschaften von s3push: 
* Datenübergabe und -speicherung durch standardisierten Cloud-Service (AWS S3)
* Hohe Verfügbarkeit, kostengünstiger Service
* Kein FTP-Server zu betreiben
* Möglichkeit der cloudbasierten Weiterverarbeitung und Trigger (AWS Lambda, SNS, SQS, Kinesis etc.)
  -- Durch die einheitlich technische Basis können Kunden generische Beispiellösungen nutzen.

Eigenschaften von FTP(-Push): 
* Eigenes Hosting bzw. durch Diensleister
* Kosten und Verfügbarkeit hängen vom Setting ab -- sind aber in Summe zumeist höher als bei AWS-S3
* In die Jahre gekommenes Protokoll
* Trigger zumeist über Filesystem-Events oder zeitbasiert über Cron-Jobs
  -- keine einheitliche technische Basis, jeder Kunde muss seine eigene Anbindung erstellen oder in Auftrag geben.

### Einrichtung auf Kundenseite

#### Self-Service im API-Portal

Kunden können ihren Zugang zu s3push selbst einrichten und verwalten. (Siehe <NavLink exact to="/api/s3push">API | s3push</NavLink>)

In unserem <a href='https://github.com/dpa-newslab' target='_blank'>Github-Repository</a> finden Sie <NavLink exact to="/doc/best-practices#s3push-anbindung">Best Practices</NavLink> basierend auf dem <a href='https://www.serverless.com' target='_blank'>serverless-Framework</a>.

Bei der Installation der Best Practices wird folgende Infrastruktur automatisch für Sie aufgebaut:
* ein S3 Bucket mit geeigneten Zugriffsrechten
* Notifikationsmechanismus mittels S3-SNS-SQS
* eine Konvertierungsfunktion, um das dpa-digitalwires Format in ihr CMS-konformes Format zu wandeln
* eine Queue, die die neuen gewandelten Topicles für ihr CMS zur Verfügung stellt

Um Meldungen per s3push zu empfangen, müssen Sie ein S3 Bucket mit geeigneten Zugriffsrechten in ihrem AWS-Account erzeugen.

Die Installationsanleitung entnehmen Sie bitte der jeweiligen README-Datei des
<a href='https://github.com/dpa-newslab' target='_blank'>Github-Projekts</a>,
für das Sie sich entschieden haben.

Bitte tragen Sie die Ausgaben für **S3-URL-Präfix**, **Access Key ID** und **Secret Access Key** im nächsten Schritt in das Formular im API-Portal ein.

Es gibt außerdem alternative Installationsmethoden.
Siehe <Navlink exact to="/doc/s3push-alternative-install">Alternative Installationsmethoden</NavLink>
  `},

// ------------------------ end s3push deep-dive 

  // ------------------------ wireq api deep-dive 
  {
    id: '617-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.navigation.doc === 'apis' &&
      apiExistsInAufschaltung(context, 'wireq'))
    },
    title: 'Dokumentation wireQ-API',
    description: `
### Überblick

Die wireQ-API ermöglicht die Belieferung aller Topicles eines Profils inklusive Metadaten
und Links auf individuelle Bildformate über eine Restful-Queue. Der wireQ-URL
steht im API-Portal zur Verfügung. (Siehe <NavLink exact to="/api/wireq">API | wireq</NavLink>)

In der Queue befinden sich alle noch nicht importierten Topicles, die sich
mittels eines einfachen Restful-Requests abrufen lassen. Nach erfolgreichem
Import werden die Topicles aus der Queue gelöscht.

![wireq-diagramm](/img/wireq-wide.png)

Im Vergleich zum jsonfeed sinkt auf der Seite des Importers der Aufwand zur
Erkennung von neuen zu importierenden Topicles. Außerdem ist die übertragene
Datenmenge geringer.

Im Falle des Ausfalls des Importers werden die Topicles zuverlässig in der Queue
vorgehalten, auch über mehrere Tage.

#### Best Practices

Auf Github hat das dpa-newslab einige Beispielimplementierungen für den Umgang mit der wireQ-API veröffentlicht:

* <NavLink exact to="/doc/best-practices#wireq-api-anbindung">wireQ-API Anbindung</NavLink>

### Vergleich wireQ-API mit jsonfeed-API

Eigenschaften von wireQ-API: 
  * einfacher HTTP-Pull-Request auf Seite des Kunden
  * Übertragung geringer Datenmengen, da nur alle noch nicht importierten Topicles abgerufen werden – geringer Aufwand zur Erkennung neu zu importierender Topicles
  * queue-basierte Belieferung
  * bei Ausfall hält Queue noch nicht abgerufene Topicles zuverlässig vor – auch über mehrere Tage

Eigenschaften von jsonfeed-API: 
  * einfacher HTTP-Pull-Request auf Seite des Kunden
  * Übertragung hoher Datenmengen, da immer alle Topicles abgerufen werden – hoher Aufwand zur Erkennung neu zu importierender Topicles

### Ressourcen:

\`\`\`bash
POST {base}/dequeue-entries.json
\`\`\`

GET und DELETE in einem Aufruf.

Es kommt ein JSON mit der Artikel-Liste zurück:
\`\`\`
{ entries: [ {...}, ... ] }
\`\`\`

---

\`\`\`bash
GET {base}/entries.json
\`\`\`

Holt neue Entries aus der Queue und macht sie für eine gewisse Zeit unsichtbar
(es werden pro Anfrage nur eine gewisse Menge an Entries geholt).

Es kommt ein JSON mit der Artikel-Liste zurück:

\`\`\`
{ entries: [ {...}, ... ] }
\`\`\`

---

\`\`\`bash
DELETE {base}/entry/{receipt}
\`\`\`

Löschen eines Entries aus der Queue. Das \`{receipt}\` findet sich im Attribut
\`_wireq_receipt\` des jeweiligen Entries.

---

\`\`\`bash
POST {base}/purge
\`\`\`

Alle Einträge aus der Queue löschen.

   `},

    {
      id: '618-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'apis' &&
        apiExistsInAufschaltung(context, 'wireq'))
      },
      title: 'Beispiel-Code wireQ-API',
      description: `
  #### GET und DELETE in einem Aufruf
  
  \`\`\`python
  def simple_receive():
      """ get and delete entries in one step """
      while True:
          partial_feed = wireq.post('dequeue-entries.json')
          for entry in partial_feed['entries']:
              yield entry
          sleep(poll_interval)
  \`\`\`

  #### GET Aufruf

  \`\`\`python
  def receive_and_process():
      """ get entries and process, delete only if processing is successful """
      while True:
          partial_feed = wireq.get('entries.json')
          for entry in partial_feed['entries']:
              receipt = entry['receipt']
              ok = process(entry)
              if ok:
                  wireq.delete('entries/'+receipt)
          sleep(poll_interval)
  \`\`\`
     `},

     {
      id: '619-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'apis' &&
        apiExistsInAufschaltung(context, 'jsonfeed'))
      },
      title: 'Dokumentation jsonfeed-API',
      description: `
### Überblick
Die jsonfeed-API ermöglicht es, alle aktuellen Topicles eines Profils inklusive
Metadaten und Links auf individuelle Bildformate mit einem einfachen HTTP-Request abzuholen.

Strukturell ähneln die Feeds den bekannten Atom-XML- oder RSS-Feeds. Als Datenformat
kommt hier jedoch JSON zum Einsatz.

Die Feeds werden vom Backend des dpa-Kunden per HTTP-GET abgeholt, hierbei handelt
sich also um ein „Pull-Szenario”. Je nach Anforderung an die Aktualität sollte
regelmäßig gepollt werden, im Abstand von 30 Sekunden bis zu mehreren Minuten.

![jsonfeed-diagramm](/img/jsonfeed-wide.png)

### Vergleich jsonfeed-API mit wireQ-API

Eigenschaften von jsonfeed-API: 
  * einfacher HTTP-Pull-Request auf Seite des Kunden
  * Übertragung hoher Datenmengen, da immer alle Topicles abgerufen werden – hoher Aufwand zur Erkennung neu zu importierender Topicles

Eigenschaften von wireQ-API: 
  * einfacher HTTP-Pull-Request auf Seite des Kunden
  * Übertragung geringer Datenmengen, da nur alle noch nicht importierten Topicles abgerufen werden – geringer Aufwand zur Erkennung neu zu importierender Topicles
  * queue-basierte Belieferung
  * bei Ausfall hält Queue noch nicht abgerufene Topicles zuverlässig vor – auch über mehrere Tage

### Conditional GET
Der jsonfeed muss regelmäßig gepollt werden, wobei sich der Feed selten innerhalb des Poll-Intervalls verändert. Um unnötigen Abrufen vorzubeugen, empfehlen wir die Implementierung eines "Conditional GET". Dazu hier zwei Beispiele zur Veranschaulichung:

#### Kommandozeile:

\`\`\`bash
curl -v -o /dev/null https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  -->
  ...ETag: "9e764579ab6a873563aa905217f6e061"

curl -v -o /dev/null -H 'If-None-Match: e809ce4015da9234d6cff180511d3a08' https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json
  --> HTTP/1.1 304 Not Modified
\`\`\`

#### Python-Beispiel:

\`\`\`python
import requests
from time import sleep


def conditional_request(url):
    poll_interval = 30
    headers = {'Content-Type': 'application/json'}
    while True:
        try:
            response = requests.get(url, headers=headers)
        except Exception as e:
            raise e

        if response.status_code == 304:
            print('The feed has not been modified!')
        resp_headers = response.headers
        etag = resp_headers.get('ETag')
        if etag:
            headers['If-None-Match'] = etag

        sleep(poll_interval)


if __name__ == '__main__':
    url = 'https://XXX.cloudfront.net/XXX/aufschaltung/au-XXX/feed/feed.json'
    conditional_request(url)
\`\`\`

### jsonfeed für Client-Apps

Auf Anfrage können wir Ihnen jsonfeeds einrichten, die mit hoher Last von vielen
Endkunden abgerufen werden können Diese jsonfeeds eignen sich für die einfache
Einbindung in mobilen Apps. Bitte sprechen Sie uns in diesem Fall an.
    `},

    {
      id: '620-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'jsonfeed-scenarios')
      },
      title: 'Anwendungsszenarien für jsonfeed',
      description: `
Im Folgenden werden verschiedene Anwendungsszenarien für jsonfeed dargestellt.
  
     `},

     {
        id: '621-de',
        kind: 'default',
        matches: (context) => {
          return (context.lang === 'de' && context.navigation.doc === 'apis' &&
          apiExistsInAufschaltung(context, 'imagewriter'))
        },
        title: 'Dokumentation Imagewriter-API',
        description: `
Es muss zunächst der Identifier eines Artikels (auch genannt "URN" -- universal ressource name) ermittelt werden. 

Im digitalwires-Format befindet sich dieser URN im Attribut **urn** des Topicles (siehe Abschnitt Formatbeschreibung bei der jeweiligen API). Die URN hat bei Weblinesartikeln in der Regel das Format: **urn:newsml:dpa.com:20090101:xxxxxx-yy-zzzzzz**

Der URN wird in das Query eingesetzt.

\`\`\`
query {
  simpleImage (urn: "urn:newsml:dpa.com:20090101:200301-99-xxx") {
    headline
    caption
    creditline
    renditions {
      url
    }
  }
}
\`\`\`

Die Response sieht folgendermaßen aus:

\`\`\`
{
  "data": {
    "simpleImage": {
      "headline": "Amtsgericht Tiergarten",
      "caption": "Ein Schild mit der Aufschrift «Amtsgericht Tiergarten».",
      "creditline": "Sven Braun/dpa/Archivbild",
      "renditions": [
        {
          "url": "https://dusbyl9uu6btk.cloudfront.net/v3/image/resize/urn:newsml:dpa.com:20090101:200301..."
        }
      ]
    }
  }
}
\`\`\`
  `},

  // ------------------------ annotation api deep-dive 
    {
      id: '622-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'apis' &&
        apiExistsInAufschaltung(context, 'annotation'))
      },
      title: 'Dokumentation Annotation-API',
      description: `
<ul>
<li><NavLink exact to="/doc/annotation-deep-dive#funktionsweise">Funktionsweise</NavLink></li>
<li><NavLink exact to="/doc/annotation-deep-dive#anfragen-mit-der-annotation-api">Anfragen mit der Annotation-API</NavLink></li>
<li><NavLink exact to="/doc/annotation-deep-dive#hinweise-für-weblinekunden">Hinweise für Weblinekunden</NavLink></li>
</ul>


### Funktionsweise

Über die Annotation-API können dpa-Kunden ergänzende Informationen zu Artikeln abrufen,
die sie via s3push, wireQ, jsonfeed oder andere Wege erhalten haben.
Der initiale Use Case ist die Auslieferung von Performant Content Metadaten an Weblineskunden,
die die Inhalte noch per FTP im Format NITF beziehen.

Die Annotation-API basiert auf GraphQL. Hierbei können die API-User auf der Grundlage
eines Schemas selber festlegen, welche Attribute sie abrufen wollen.
Die Annotation-API lässt sich direkt im API-Portal ausprobieren.
(Siehe <NavLink exact to="/api/annotation">API | annotation</NavLink>)

Der Ablauf sieht auf Seiten des dpa-Kunden so aus:

* Artikel-ID ermitteln
* GraphQL-Anfrage stellen
* Ergebnis auswerten

![annotation-api-diagramm](/img/annotation-wide.png)


### Anfragen mit der Annotation-API

#### Use Case Abruf von „Performant Content Metadaten”

Im Folgenden wird beispielhaft beschrieben, wie im Zusammenhang mit dem Abruf von
„Performant Content Metadaten” die Werte **limbicsystem**, **lifetime** oder **importance**
eines Artikels abgerufen werden.

Es sollen abgefragt werden:

* die addressierte Zielgruppe eines Artikels im **limbicsystem**
* die „Wichtigkeit” des Artikels: **importance**
* die „Lebensdauer” des Artikels **lifetime**

Dazu muss zunächst der Identifier eines Artikels (auch genannt "URN" -- universal ressource name) ermittelt werden. 

Im digitalwires-Format befindet sich dieser URN im Attribut **urn** des Topicles (siehe Abschnitt Formatbeschreibung bei der jeweiligen API). Die URN hat bei Weblinesartikeln in der Regel das Format: **urn:newsml:dpa.com:20090101:xxxxxx-yy-zzzzzz**

Existierende Weblineskunden, die die Weblines via FTP und NITF beziehen, beachten
bitte die [Hinweise für Weblinekunden](#hinweise-für-weblinekunden) am Ende.

Der URN wird in das Query eingesetzt (wobei Sie auch eine Liste von URNs angeben können).
Im Beispiel verwenden wir die URN eines Testartikels.

\`\`\`
query {
 get_annotations(urns:["urn:dnltest:advicedemo:201901:001"]) {
    items {
      ... on Advice {
        type
        subject { urn }
        limbicsystem {qcode }
        lifetime { qcode }
        importance { qcode }
      }
    }
  }
}
\`\`\`

Die Response sieht folgendermaßen aus:

\`\`\`
 {
  "data": {
    "get_annotations": {
      "items": [
        {
          "type": "dnltype:publishadvice",
          "subject": {
            "urn": "urn:dnltest:advicedemo:201901:001"
          },
          "limbicsystem": {
            "qcode": "dpa-limbic-system:dominance"
          },
          "lifetime": {
            "qcode": "advice-lifetime:long"
          },
          "importance": {
            "qcode": "advice-importance:useful"
          }
        }
      ]
    }
  }
}
\`\`\`

Die so erhaltenen Werte können Sie dann in ihr CMS oder ein anderes internes System übernehmen.

### Hinweise für Weblinekunden

 * Um ihnen die Nutzung der Annotation-API einfacher zu machen, unterstützen wir auch das ID-Format der Weblines, das Sie im Wert des **id-string**-Attributes des \`<doc-id>\`-Tags finden.
 * Diese ID hat typischerweise das Format: **urn-newsml-dpa-com-20090101-xxxxxx-yy-zzzzzz:iiiiiiiiiiiii**

     `},

  {
    id: '623-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'electionsdata'))
    },
    title: 'Was ist die electionsdata-API?',
    description: `
Die Electionsdata-API ermöglicht den Zugriff auf Daten im Zusammenhang mit Wahlen über eine Restful-API. 
  * Wahlergebnisse
  * Umfragen
  * Kandidaten
  * Termine und Informationen

Der electionsdata-URL steht im API-Portal zur Verfügung. (Siehe <NavLink exact to="/api/electionsdata">API | electionsdata</NavLink>)

Details zu den Ressourcen und Parametern finden Sie in der <a href="https://swagger.dpa-electionsdata.com" target="_blank">Beschreibung der electionsdata-API</a>.

`},


/*******       
  {
    id: '623-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'survey'))
    },
    title: 'Was ist die survey-API?',
    description: `
Die Survey-API ermöglicht den Zugriff auf Umfrageergebnisse über eine Restful-API.
Der survey-URL steht im API-Portal zur Verfügung. (Siehe <NavLink exact to="/api/survey">API | survey</NavLink>)

### GET <base>/surveys<parameters>

Die API gibt, je nach Anfrageparametern, Umfragedaten für jedes europäisches Parlament und
für einen Zeitraum von bis zu 4 Jahren zurück. Die Daten kommen im  JSON-Format, ein
Dokumentation über die Struktur finden Sie <NavLink exact to='/res/survey_response.txt' target='_blank'>hier</NavLink>.

### example url

  <base>/surveys?source=source21&minified=false&office=at_1&date=2019-03-16

### parameters

- **office** (String)  
Steuert, für welches Parlament die Umfragedaten ausgegeben werden sollen. Wird office
nicht übergeben, greift der default-Wert _de_1_ (Bundestag). Eine Liste der IDs für
die Parlamente finden Sie hier.
- **date** (String - optional)
Steuert den Zeitraum, für welchen Umfragedaten ausgegeben werden sollen. Wird date 
nicht übergeben, werden Umfragedaten für die vergangenen 12 Monate ausgegeben. Mögliche Werte sind: 
    - YYYY-MM-DD --> Zurückliegendes Datum.  Beispiel: date=2020-01-01 gibt Umfragen zwischen dem 1.1.2020 und dem Tag der API-Anfrage zurück.
    - lastElection --> Damit werden Umfragen seit der letzten Wahl des Landes zurückgegeben, inklusive des letzten Wahlergebnisses. Liegt die Wahl weniger als 12 Monate zurück, werden die Umfragen der letzten 12 Monate ausgegeben.
- **lastSurvey** (Boolean - optional)  
Steuert, ob die Umfrage vor dem angefragten Datum mitgeliefert werden soll. Der default-Wert ist false.
- **source** (String - optional)  
Steuert, von welchen Quellen die Umfragen stammen sollen.  Mögliche Werte sind:
    - latest --> Es werden die Umfragen des Institutes ausgegeben, das die aktuellste Umfrage veröffentlicht hat. Dies ist der default-Wert.
    - all --> Es werden die Umfragen von allen Instituten ausgegeben, von denen über einen längeren Zeitraum Unfragen vorliegen.
    - sourceXX --> Es werden nur die Umfragen eines bestimmten Institutes ausgegeben. Die Quellen, die für ein Parlament verfügbar sind, werden in der API-Antwort aufgelistet. Bitte wenden Sie sich an uns, wenn Sie die ID für ein bestimmtes Institut benötigen.
- **language** (String - optional)  
Steuert, in welcher Sprache die Namen für die Parteien, die Institute und das Parlament ausgegeben werden. Mögliche Werte:
    - de --> default
    - en
- **minified** (Boolean - optional)  
Steuert den Datenumfang der Umfragen. Wird minified=true übergeben, werden nur die IDs, nicht aber die Farben und Namen der Parteien ausgegeben. Kann angewendet werden, wenn eigene Partei-Bezeichnungen und -Farben verwendet und anhand der IDs gemappt werden sollen. Der default-Wert ist false.
`},
****/

      
// ------------------------ dpa-digitalwires format
{
  id: '624-de',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'de' && context.navigation.doc === 'format')
  },
  title: 'Das dpa-digitalwires-Format',
  description: format
},
// ------------------------ faq
{
  id: '625-de',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'de' && context.navigation.doc === 'faq')
  },
  title: 'FAQ',
  description: faq
}
,
// ------------------------ best practices
{
  id: '626-de',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'de' && context.navigation.doc === 'best-practices')
  },
  title: 'Best Practices',
  description: best_practices
},

{
  id: '627-de',
  kind: 'default',
  matches: (context) => {
    return (context.lang === 'de' && context.navigation.doc === 'overview' &&
      apiExistsInAufschaltung(context, 'sftppush'))
  },
  title: 'Was ist die sftppush-API?',
  description: `
Sftppush überträgt neue oder aktualisierte Artikel direkt zum SFTP-Server
des dpa-Kunden. Von dort können die Artikel regelmäßig abgeholt werden.

Mehr zum Thema:
  * <Navlink exact to="/doc/apis#dokumentation-sftppush-api">Dokumentation sftppush-API</NavLink>
`},


  // ------------------------ sftppush deep-dive 
  {
    id: '628-de',
    kind: 'default',
    matches: (context) => {
      return (context.lang === 'de' && context.navigation.doc === 'apis' &&
      apiExistsInAufschaltung(context, 'sftppush'))
    },
    title: 'Dokumentation sftppush-API',
    description: `
### Überblick
Sftppush überträgt neue oder aktualisierte Artikel direkt auf den SFTP-Server des dpa-Kunden.

  `},

    // ------------------------ news
    {
      id: '629-de',
      kind: 'default',
      matches: (context) => {
        return (context.lang === 'de' && context.navigation.doc === 'news')
      },
      title: 'Aktuelles',
      description: news
    }
  ]

export { cardDefinitionsDe }



// WEBPACK FOOTER //
// ./src/all_cards/card_definitions_de.js